import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "conversation-header"
}
const _hoisted_2 = { class: "conversation-header__text" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "description" }

import { n, t } from '@nextcloud/l10n'
import { usernameToColor } from '@nextcloud/vue/functions/usernameToColor'
import { computed, watch } from 'vue'
import { useStore } from 'vuex'
import NcActionButton from '@nextcloud/vue/components/NcActionButton'
import NcActions from '@nextcloud/vue/components/NcActions'
import NcButton from '@nextcloud/vue/components/NcButton'
import IconArrowLeft from 'vue-material-design-icons/ArrowLeft.vue'
import IconChevronRight from 'vue-material-design-icons/ChevronRight.vue'
import IconForumOutline from 'vue-material-design-icons/ForumOutline.vue'
import IconPencilOutline from 'vue-material-design-icons/PencilOutline.vue'
import { useGetThreadId } from '../../../composables/useGetThreadId.ts'
import { useGetToken } from '../../../composables/useGetToken.ts'
import { PARTICIPANT } from '../../../constants.ts'
import { useActorStore } from '../../../stores/actor.ts'
import { useChatExtrasStore } from '../../../stores/chatExtras.ts'
import { notificationLevelIcons, notificationLevels } from './threadsConstants.ts'


export default /*@__PURE__*/_defineComponent({
  __name: 'ThreadHeader',
  props: {
    standalone: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const actorStore = useActorStore()
const chatExtrasStore = useChatExtrasStore()
const threadId = useGetThreadId()
const token = useGetToken()
const store = useStore()

const currentThread = computed(() => chatExtrasStore.getThread(token.value, threadId.value))

const threadNotification = computed(() => currentThread.value?.attendee.notificationLevel ?? PARTICIPANT.NOTIFY.DEFAULT)

const threadNotificationVariant = computed(() => {
	return ([PARTICIPANT.NOTIFY.ALWAYS, PARTICIPANT.NOTIFY.MENTION].includes(threadNotification.value))
		? 'secondary'
		: 'tertiary'
})

const isModeratorOrOwner = computed(() => {
	return store.getters.isModerator
		|| (currentThread.value?.first?.actorId === actorStore.actorId && currentThread.value?.first?.actorType === actorStore.actorType)
})

watch(currentThread, (value) => {
	if (threadId.value && value === undefined) {
		chatExtrasStore.fetchSingleThread(token.value, threadId.value)
	}
}, { immediate: true })

/**
 * Rename a thread title on server
 */
async function renameThreadTitle() {
	await chatExtrasStore.renameThread(token.value, threadId.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["thread-header", { 'thread-header--standalone': __props.standalone }])
  }, [
    (__props.standalone)
      ? (_openBlock(), _createBlock(_unref(NcButton), {
          key: 0,
          title: _unref(t)('spreed', 'Back'),
          "aria-label": _unref(t)('spreed', 'Back'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (threadId.value = 0))
        }, {
          icon: _withCtx(() => [
            _createVNode(IconArrowLeft, {
              class: "bidirectional-icon",
              size: 20
            })
          ]),
          _: 1
        }, 8, ["title", "aria-label"]))
      : (_openBlock(), _createBlock(IconChevronRight, {
          key: 1,
          class: "bidirectional-icon",
          size: 20
        })),
    (currentThread.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "conversation-header__thread-icon",
            style: _normalizeStyle({ '--color-thread-icon': _unref(usernameToColor)(currentThread.value.thread.title).color })
          }, [
            _createVNode(IconForumOutline, { size: 20 })
          ], 4),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(currentThread.value.thread.title), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(n)('spreed', '%n reply', '%n replies', currentThread.value.thread.numReplies)), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(NcActions), {
      "aria-label": _unref(t)('spreed', 'Thread notifications'),
      title: _unref(t)('spreed', 'Thread notifications'),
      variant: threadNotificationVariant.value
    }, {
      icon: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(notificationLevelIcons)[threadNotification.value]), { size: 20 }))
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notificationLevels), (level) => {
          return (_openBlock(), _createBlock(_unref(NcActionButton), {
            key: level.value,
            "model-value": threadNotification.value.toString(),
            value: level.value.toString(),
            description: level.description,
            type: "radio",
            "close-after-click": "",
            onClick: ($event: any) => (_unref(chatExtrasStore).setThreadNotificationLevel(_unref(token), _unref(threadId), level.value))
          }, {
            icon: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(notificationLevelIcons)[level.value]), { size: 20 }))
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(level.label), 1)
            ]),
            _: 2
          }, 1032, ["model-value", "value", "description", "onClick"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["aria-label", "title", "variant"]),
    (isModeratorOrOwner.value)
      ? (_openBlock(), _createBlock(_unref(NcActions), {
          key: 3,
          "aria-label": _unref(t)('spreed', 'Thread actions'),
          title: _unref(t)('spreed', 'Thread actions'),
          "force-menu": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NcActionButton), {
              key: "rename-thread",
              "close-after-click": "",
              onClick: renameThreadTitle
            }, {
              icon: _withCtx(() => [
                _createVNode(IconPencilOutline, { size: 20 })
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_unref(t)('spreed', 'Edit thread details')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["aria-label", "title"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})